// src/routes/PublicRoute.jsx
import { Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";

const Public = ({ Component, isLoginPage = false, isPublicPage = false }) => {
    const [cookies] = useCookies(['authtoken', 'expiry']);
    const isAuthenticated = cookies.authtoken && cookies.expiry && Date.now() < Date.parse(cookies.expiry);

    // For public pages that should redirect if authenticated (home, about, etc.)
    if (isPublicPage) {
        return isAuthenticated ? <Navigate to="/Overview" /> : <Component />;
    }
    
    // For login/signup pages - redirect if authenticated
    if (isLoginPage) {
        return isAuthenticated ? <Navigate to="/Overview" /> : <Component />;
    }
    
    // For truly public pages that don't need redirection (if any)
    return <Component />;
};

export default Public;